import React, { useState } from 'react';
import { Popover } from 'antd';
import FisheryMarker from '../assets/images/FisheryMarker.js';
import SearchResultCard from './SearchResultCard';

export default function MapPopover(props) {
  const [visible, setVisible] = useState(false);

  const cluster = props.data;

  const fisheryMarkerColour = visible
    ? 'sb-blue-900'
    : cluster.is_bookable
      ? 'sb-blue-700'
      : 'seagreen-700';

  return (
    <Popover
      id='sb-map-popover-content'
      content={
        <div className='sb-map-popover-content'>
          <SearchResultCard
            fisheryId={cluster.id}
            name={cluster.name}
            address={`${cluster.city}, ${cluster.postcode}`}
            thumbnail={cluster.images?.[0]}
            data={{ ...cluster, id: cluster?.private_id }}
            bookable={cluster.is_bookable}
            initialIsFavourite={cluster.is_favourite}
            showDetails={false}
          />
        </div>
      }
      trigger='click'
      open={visible}
      onOpenChange={(visible) => {
        setVisible(visible);
      }}
    >
      <p className='map-fishery-marker'>
        <FisheryMarker
          className={fisheryMarkerColour + ' fs-40 cp'}
          id={'open-popover-' + cluster.id}
        />
      </p>
    </Popover>
  );
}
